var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15958_53842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    transform: "matrix(1 0 0 -1 11 18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 22C6.7925 22 2.3125 17.52 2.3125 12C2.3125 6.48 6.7925 2 12.3125 2C17.8325 2 22.3125 6.48 22.3125 12C22.3125 17.52 17.8325 22 12.3125 22ZM13.3125 7H11.3125V13H13.3125V7ZM13.3125 15H11.3125V17H13.3125V15Z",
    fill: "#F25C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15958_53842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastError);
export default __webpack_public_path__ + "static/media/icon_toast_error.97a8f27b2fa0d8d0e155696e24a97de4.svg";
export { ForwardRef as ReactComponent };